import React, { useState, useEffect } from 'react';
import { Button, Stack, Typography } from '@mui/material';

const ResendOtp = ({ onResend = () => {} }) => {
  const [counter, setCounter] = useState(60);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    if (counter === 0) {
      setIsButtonDisabled(false);
    }
    return () => clearInterval(timer);
  }, [counter]);

  const handleResendOtp = () => {
    setCounter(60);
    setIsButtonDisabled(true);
    onResend();
  };

  return (
    <Stack
      spacing={1}
      direction={'row'}
      alignItems={'center'}
      alignContent={'center'}
      sx={{ my: isButtonDisabled ? 2 : 1 }}
    >
      {counter > 0 && (
        <Typography color='white' >
          Resend OTP in {counter} seconds
        </Typography>
      )}
      {!isButtonDisabled && (
        <Button
          variant='text'
          color='primary'
          onClick={handleResendOtp}
        >
          Resend OTP
        </Button>
      )}
      
    </Stack>
  );
};

export default ResendOtp;
